import {TagSchemaSummary} from 'constants/RegistryConstants';
import {ClientSchemaField, createClientSchemaField} from 'registry/field/FieldTable';
import * as SchemaFieldConstants from 'schemas/fields/SchemaFieldConstants';

import {TagSchemaSummaryGraphQL} from '../../../graphql-fragments/schemas/tag-schemas/__generated/TagSchemaSummaryGraphQL';
import {COMPOUND_FIELD_DISPLAY_NAME, COMPOUND_FIELD_SYSTEM_NAME} from './MoleculeSchemaInterfaceConstants';

/**
 * Creates a pre-populated Compound field for the Molecule Form SSI.
 * The field links to the given Molecule Compound schema via Base Molecule Link.
 */
export function createCompoundField(
  targetCompoundSchema: TagSchemaSummary | TagSchemaSummaryGraphQL
): ClientSchemaField {
  const base = createClientSchemaField(COMPOUND_FIELD_DISPLAY_NAME, COMPOUND_FIELD_SYSTEM_NAME);
  return {
    ...base,
    fieldType: SchemaFieldConstants.FieldType.BASE_MOLECULE_LINK,
    isRequired: true,
    isParentLink: true,
    requiredLink: {
      tagSchema: targetCompoundSchema,
      entitySchemaFieldPath: null,
      folderItemType: null,
      schemaInterface: null,
    },
  };
}
